import { Registry } from "./Registry";


export interface Transformation extends Registry<string, any, any> {
    transform( data:any ):any;
}


export class Gateway {

    in:Transformation;
    out:Transformation;

    constructor( transformations:{ in?:Transformation, out?:Transformation } = {} ) {
        this.in = transformations.in ?? new InTransform();
        this.out = transformations.out ?? new OutTransform();
    }
}


export interface KeyLookup {
    ( any ): string;
}


export class InTransform extends Registry<string, any, any> implements Transformation {

    lookup: KeyLookup;

    constructor( lookup: KeyLookup = defaultLookup ) {
        super();
        this.lookup = lookup;
    }


    transform( data: any ) {

        // handle arrays
        if( Array.isArray( data ) ) {
            return data.map( item => this.transform( item ) );
        }

        // handle objects
        if( typeof data === 'object' && data !== null ) {

            let factory = this.get( this.lookup( data ) );

            Object.keys( data ).forEach( name => {
                data[ name ] = this.transform( data[ name ] );
            } );

            return ( factory ) ? factory( data ) : data;
        }

        return data;
    }
}



export class OutTransform extends Registry<string, any, any> implements Transformation {

    lookup: KeyLookup;

    constructor( lookup: KeyLookup = defaultLookup ) {
        super();
        this.lookup = lookup;
    }

    transform( data: any ) {

        let factory = this.get( this.lookup( data ) );
        data = ( factory ) ? factory( data ) : data;

        // handle arrays
        if( Array.isArray( data ) ) {
            data = data.map( item => this.transform( item ) );
        }

        // handle objects
        if( typeof data === 'object' && data !== null ) {


            Object.keys( data ).forEach( name => {
                data[ name ] = this.transform( data[ name ] );
            } );
        }

        return data;
    }
}



function defaultLookup( d: any ) {
    return d?.modelName || 'default';
}
